import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-disable-experience',
  templateUrl: './disable-experience.component.html',
  styleUrls: ['./disable-experience.component.scss']
})
export class DisableExperienceComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
